
<div class="page-customized">
    <v-progress-linear
        v-if="overlay"
        absolute
        indeterminate
    ></v-progress-linear>

    <app-bar
        :title="externalContent.exists() ? t('external_content_title_update') : t('external_content_title_create')"
        back="/external-contents"
    />

    <v-layout class="mt-n8">
        <v-card
            width="100%"
            color="transparent"
            elevation="0"
            class="pb-8"
        >
            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('external_content_label_name') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="externalContent.name"
                                type="text"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('name')"
                            ></v-text-field>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="externalContent.name"
                                :items="externalContent.translations['name']"
                                @touch="(v) => externalContent.translations['name'] = v"
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('external_content_label_type') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="externalContent.type"
                                :items="externalContentTypes()"
                                required
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('type')"
                            ></v-select>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('external_content_label_url') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="externalContent.url"
                                type="text"
                                required
                                outlined
                                dense
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('external_content_label_description') }}</div>
                        <div class="horizontal-input">
                            <tinymce
                                key="description"
                                v-model="externalContent.description"
                            ></tinymce>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="externalContent.description"
                                :items="externalContent.translations['description']"
                                @touch="(v) => externalContent.translations['description'] = v"
                                editor
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('general_action_published') }}</div>
                        <div class="horizontal-input">
                            <v-switch
                                class="ma-0"
                                v-model="externalContent.published"
                            ></v-switch>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-4 pt-8">
                <v-btn
                    :to="{ name: 'external-contents' }"
                    class="mr-4"
                    color="primary"
                >{{ t('general_action_cancel') }}</v-btn>
                <v-btn
                    :loading="form.busy"
                    :disabled="form.busy"
                    color="orange"
                    @click.prexternalContent="submit"
                >{{ externalContent.exists() ? t('general_action_save') : t('external_content_title_create') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</div>
